import { createAction } from '@reduxjs/toolkit';

import { capitalize } from './strings';

export type LooseActionCreator = {
  (payload?: unknown): { type: string; payload?: unknown };
  type: string;
};

export const createActions = (
  namespace: string,
  types: string[],
): Record<string, LooseActionCreator> => {
  return types.reduce<Record<string, LooseActionCreator>>((actions, type) => {
    const key = `${namespace}${capitalize(type)}`;
    actions[key] = createAction(
      `${namespace}/${type}`,
    ) as unknown as LooseActionCreator;
    return actions;
  }, {});
};
